import {handleResponse, requestTimeout} from '../utils'
// import { Cookies } from 'react-cookie'

const apiUrl = process.env.REACT_APP_API_URL
const apiMaxTime = process.env.REACT_APP_API_EXEC_TIME
// const cookie = new Cookies();

export const transactionApi = {
    _get,    
    _add,
    _update,
    _delete,
};



async function _get(offset, filters, page_size) {    
    
    const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE)   

    const requestOptions = {
        method: 'POST',
        credentials: "include",
        headers: {
            'Authorization': 'Bearer '+ token,
            'Accept': 'application/json',            
        },
        body: JSON.stringify(filters)       
    };
    return requestTimeout(apiMaxTime,fetch(apiUrl + 'transactions/'+offset+'/'+page_size, requestOptions))
                .then(handleResponse)
                .then((response) => {                    
                    return response
                });    
}


async function _add(form_data) {
    const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE)   
    const requestOptions = {
        method: 'POST',
        credentials: "include",
        headers: {
            'Authorization': 'Bearer '+ token,
            'Accept': 'application/json',            
        },
        body: form_data
    };
    return requestTimeout(apiMaxTime,fetch(apiUrl + 'section/topics', requestOptions))
                .then(handleResponse)
                .then((response) => {                    
                    return response
                });
}

async function _update(form_data, id) {
    const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE)   
    const requestOptions = {
        method: 'POST',
        credentials: "include",
        headers: {
            'Authorization': 'Bearer '+ token,
            'Accept': 'application/json'
        },
        body: form_data
    };
    return requestTimeout(apiMaxTime,fetch(apiUrl + 'section/topics/'+id, requestOptions))
                .then(handleResponse)
                .then((response) => {                    
                    return response
                });
}


async function _delete(id) {
    const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE)   
    const requestOptions = {
        method: 'DELETE',
        credentials: "include",
        headers: {
            'Authorization': 'Bearer '+ token,
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }        
    };    
    return requestTimeout(apiMaxTime,fetch(apiUrl + 'section/topics/'+id, requestOptions))
                .then(handleResponse)
                .then((response) => {                    
                    return response
                });
}